export default __webpack_public_path__ + "static/media/Post-notification.41a664af.png";